import 'css-chunksrc/client/scenes/optimizedGantt/resources/styles.scss';export default {
  "header": "_header_ffu7c_1",
  "row": "_row_ffu7c_7",
  "label": "_label_ffu7c_17",
  "resource": "_resource_ffu7c_34",
  "actions": "_actions_ffu7c_41",
  "icon": "_icon_ffu7c_50"
};